import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EErrorNotificationActionType } from './types';

export const clearErrorNotification = actionGenerator<EErrorNotificationActionType.Cleared>(
  EErrorNotificationActionType.Cleared,
);
